import RMButton from 'components/customComponents/Controls/RMButton';
import { useModalHandlers } from 'components/modal';
import useSendTestEmail from 'CustomHooks/useSendTestEmail';
import React from 'react';
import DownloadLogModal from './DownloadLogModal';

export const General = () => {
  const { showModal, hideModal } = useModalHandlers();

  const handleOnClickDownloadLogs = () => {
    showModal({
      heading: 'Download Log',
      body: <DownloadLogModal hideModal={hideModal} showModal={showModal} />,
      showButtons: false,
      dialogClassName: 'max-w-[600px] w-[600px]',
      headerClassName: 'text-black',
    });
  };
  const handleGenerateTestEmail = useSendTestEmail();
  return (
    <div
      id="general-support-wrapper"
      className="border-1 border-solid border-[#E0E0E0] h-[100%] w-[100%] p-2"
    >
      <b id="general-support-title" className="text-[14px] 2xl:text-[18px]">
        General
      </b>
      <div
        id="general-support-content-downloadlogfile"
        className="flex items-center w-full mt-4"
      >
        <div
          id="general-support-content-downloadlogfile-title"
          className="flex-grow text-[12px] 2xl:text-[16px]"
        >
          Download Log Files
        </div>
        <div id="general-support-content-downloadlogfile-button" className="text-right">
          <RMButton
            className="text-[13px] w-[79px]"
            customStyle={{ background: '#000000' }}
            onClick={handleOnClickDownloadLogs}
            disabled={false}
            label="OPEN"
          />
        </div>
      </div>
      <div
        id="general-content-generatetestemail"
        className="flex items-center w-full mt-2"
      >
        <div
          id="general-content-generatetestemail-title"
          className="flex-grow text-[12px] 2xl:text-[16px]"
        >
          Generate Test Email
        </div>
        <div id="general-content-generatetestemail-button" className="text-right">
          <RMButton
            className="text-[13px] w-[79px]"
            customStyle={{ background: '#000000' }}
            onClick={handleGenerateTestEmail}
            disabled={false}
            label="SEND"
          />
        </div>
      </div>
    </div>
  );
};
